import services from 'utils/mockAdapter';
// user list
const statics = [
    {
        param: 'Software Version',
        paramvalue: '2.09.98',
        parmdefault: '',
        lastchanged: '22-Jan-2022 19:21'
    },
    {
        param: 'Total Trip Counters',
        paramvalue: '313',
        parmdefault: '',
        lastchanged: '22-Jan-2022 19:21'
    },
    {
        param: 'Trips From Last Service',
        paramvalue: '89',
        parmdefault: '',
        lastchanged: '22-Jan-2022 19:21'
    },
    {
        param: 'Total Run Timer',
        paramvalue: '15',
        parmdefault: '',
        lastchanged: '22-Jan-2022 19:21'
    },
    {
        param: 'Laset Service Timer',
        paramvalue: '2.09.98',
        parmdefault: '',
        lastchanged: '20-Jul-2021 15:52'
    },
    {
        param: 'Releveling Count',
        paramvalue: '43',
        parmdefault: '',
        lastchanged: '22-Jan-2022 19:21'
    },
    {
        param: 'Door Cycling Counter',
        paramvalue: '180',
        parmdefault: '',
        lastchanged: '22-Jan-2022 19:21'
    }
];

// ==============================|| MOCK SERVICES ||============================== //

services.onGet('/api/staticlist/list').reply(200, { statics });
